<h2 mat-dialog-title>{{title}}</h2>
<mat-dialog-content>
    @if (message) {
    {{message}}
    }
    @if(selectedDates){
    @for(date of selectedDates; track date){
    <div class="date">
        <p>{{date}}</p>
    </div>
    }
    }
</mat-dialog-content>
<mat-divider></mat-divider>
<mat-dialog-actions align="end">
    <button mat-button class="cancel-delete" (click)="onCancel()">{{cancelText}}</button>
    <button mat-button class="delete" (click)="deleteSelected()">{{confirmText}}</button>
</mat-dialog-actions>